import { Employee } from './EmployeeDataTable';
import Data from './Data/Data.json'

export const data = Data;
